import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
// Calendar
import Waitlist from '../components/Dashboard/Views/Waitlist/Waitlist.vue'

//BWP
import RoomFoodAdd from '../components/Dashboard/Views/RoomFood/Add.vue'
import RoomFoodList from '../components/Dashboard/Views/RoomFood/List.vue'
import RoomFoodEdit from '../components/Dashboard/Views/RoomFood/Edit.vue'

import RoomDrinkAdd from '../components/Dashboard/Views/RoomDrink/Add.vue'
import RoomDrinkList from '../components/Dashboard/Views/RoomDrink/List.vue'
import RoomDrinkEdit from '../components/Dashboard/Views/RoomDrink/Edit.vue'

import LobbyFoodAdd from '../components/Dashboard/Views/LobbyFood/Add.vue'
import LobbyFoodList from '../components/Dashboard/Views/LobbyFood/List.vue'
import LobbyFoodEdit from '../components/Dashboard/Views/LobbyFood/Edit.vue'

import LobbyBreakfastAdd from '../components/Dashboard/Views/LobbyBreakfast/Add.vue'
import LobbyBreakfastList from '../components/Dashboard/Views/LobbyBreakfast/List.vue'
import LobbyBreakfastEdit from '../components/Dashboard/Views/LobbyBreakfast/Edit.vue'

import LobbyDrinkAdd from '../components/Dashboard/Views/LobbyDrink/Add.vue'
import LobbyDrinkList from '../components/Dashboard/Views/LobbyDrink/List.vue'
import LobbyDrinkEdit from '../components/Dashboard/Views/LobbyDrink/Edit.vue'

import LoungeFoodAdd from '../components/Dashboard/Views/LoungeFood/Add.vue'
import LoungeFoodList from '../components/Dashboard/Views/LoungeFood/List.vue'
import LoungeFoodEdit from '../components/Dashboard/Views/LoungeFood/Edit.vue'

import LoungeDrinkAdd from '../components/Dashboard/Views/LoungeDrink/Add.vue'
import LoungeDrinkList from '../components/Dashboard/Views/LoungeDrink/List.vue'
import LoungeDrinkEdit from '../components/Dashboard/Views/LoungeDrink/Edit.vue'


import RestaurantFoodAdd from '../components/Dashboard/Views/RestaurantFood/Add.vue'
import RestaurantFoodList from '../components/Dashboard/Views/RestaurantFood/List.vue'
import RestaurantFoodEdit from '../components/Dashboard/Views/RestaurantFood/Edit.vue'

import RestaurantDrinkAdd from '../components/Dashboard/Views/RestaurantDrink/Add.vue'
import RestaurantDrinkList from '../components/Dashboard/Views/RestaurantDrink/List.vue'
import RestaurantDrinkEdit from '../components/Dashboard/Views/RestaurantDrink/Edit.vue'

import RoomDirectory from '../components/Dashboard/Views/RoomDirectory/Edit.vue'


// BWP
const WaitList = () =>
    import ( /* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Waitlist/Waitlist.vue');

const Settings = () =>
    import ( /* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Settings/Settings.vue');


let restaurantfood = {
    path: '/restaurantfood',
    component: DashboardLayout,
    redirect: '/restaurantfood/list',
    children: [{
            path: 'list',
            name: 'Restaurant-Food-List',
            component: RestaurantFoodList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Restaurant-Food-Add',
            component: RestaurantFoodAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Restaurant-Food-Edit',
            component: RestaurantFoodEdit,
            meta: { requiresAuth: true },
        }
    ]
}

let restaurantdrink = {
    path: '/restaurantdrink',
    component: DashboardLayout,
    redirect: '/restaurantdrink/list',
    children: [{
            path: 'list',
            name: 'Restaurant-Drink-List',
            component: RestaurantDrinkList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Restaurant-Drink-Add',
            component: RestaurantDrinkAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Restaurant-Drink-Edit',
            component: RestaurantDrinkEdit,
            meta: { requiresAuth: true },
        }
    ]
}


let loungefood = {
    path: '/loungefood',
    component: DashboardLayout,
    redirect: '/loungefood/list',
    children: [{
            path: 'list',
            name: 'Lounge-Food-List',
            component: LoungeFoodList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Lounge-Food-Add',
            component: LoungeFoodAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Lounge-Food-Edit',
            component: LoungeFoodEdit,
            meta: { requiresAuth: true },
        }
    ]
}


let loungedrink = {
    path: '/loungedrink',
    component: DashboardLayout,
    redirect: '/loungedrink/list',
    children: [{
            path: 'list',
            name: 'Lounge-Drink-List',
            component: LoungeDrinkList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Lounge-Drink-Add',
            component: LoungeDrinkAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Lounge-Drink-Edit',
            component: LoungeDrinkEdit,
            meta: { requiresAuth: true },
        }
    ]
}


let lobbyfood = {
    path: '/lobbyfood',
    component: DashboardLayout,
    redirect: '/lobbyfood/list',
    children: [{
            path: 'list',
            name: 'Lobby-Food-List',
            component: LobbyFoodList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Lobby-Food-Add',
            component: LobbyFoodAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Lobby-Food-Edit',
            component: LobbyFoodEdit,
            meta: { requiresAuth: true },
        }
    ]
}

let lobbybreakfast = {
    path: '/lobbybreakfast',
    component: DashboardLayout,
    redirect: '/lobbybreakfast/list',
    children: [{
            path: 'list',
            name: 'Lobby-Breakfast-List',
            component: LobbyBreakfastList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Lobby-Breakfast-Add',
            component: LobbyBreakfastAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Lobby-Breakfast-Edit',
            component: LobbyBreakfastEdit,
            meta: { requiresAuth: true },
        }
    ]
}


let lobbydrink = {
    path: '/lobbydrink',
    component: DashboardLayout,
    redirect: '/lobbydrink/list',
    children: [{
            path: 'list',
            name: 'Lobby-Drink-List',
            component: LobbyDrinkList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Lobby-Drink-Add',
            component: LobbyDrinkAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Lobby-Drink-Edit',
            component: LobbyDrinkEdit,
            meta: { requiresAuth: true },
        }
    ]
}

let roomfood = {
    path: '/roomfood',
    component: DashboardLayout,
    redirect: '/roomfood/list',
    children: [{
            path: 'list',
            name: 'Room-Food-List',
            component: RoomFoodList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Room-Food-Add',
            component: RoomFoodAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Room-Food-Edit',
            component: RoomFoodEdit,
            meta: { requiresAuth: true },
        }
    ]
}

let roomdrink = {
    path: '/roomdrink',
    component: DashboardLayout,
    redirect: '/roomdrink/list',
    children: [{
            path: 'list',
            name: 'Room-Drink-List',
            component: RoomDrinkList,
            meta: { requiresAuth: true },
        },
        {
            path: 'add',
            name: 'Room-Drink-Add',
            component: RoomDrinkAdd,
            meta: { requiresAuth: true },
        },
        {
            path: 'edit/:id',
            name: 'Room-Drink-Edit',
            component: RoomDrinkEdit,
            meta: { requiresAuth: true },
        }
    ]
}

let settings = {
    path: '/settings',
    component: DashboardLayout,
    redirect: '/settings/password',
    children: [{
        path: 'password',
        name: 'Password',
        component: Settings,
        meta: { requiresAuth: true },
    }]
}

let roomdirectory = {
    path: '/directory',
    component: DashboardLayout,
    redirect: '/directory/edit',
    children: [{
        path: 'edit',
        name: 'Directory-Edit',
        component: RoomDirectory,
        meta: { requiresAuth: true },
    }]
}

let loginPage = {
    path: '/login',
    name: 'Login',
    component: Login
}

const routes = [{
        path: '/',
        component: DashboardLayout,
        redirect: '/lobbyfood',
        children: [{
            path: '/list',
            name: 'Lobby-Food-List',
            component: LobbyDrinkList
        }]
    },
    loungefood,
    loungedrink,
    restaurantfood,
    restaurantdrink,
    loginPage,
    settings,
    lobbyfood,
    lobbybreakfast,
    lobbydrink,
    roomdirectory,
    roomfood,
    roomdrink,
    { path: '*', component: NotFound }
];

export default routes